import React, { PropsWithChildren, useCallback, useContext, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { GameHowToPlayModalRef, HowToPlayContent } from './GameHowToPlayModal';
import { GameHowToPlayModal } from './GameHowToPlayModal';

type GameHowToPlayContextType = {
    showGameHowToPlay: (content: HowToPlayContent) => void;
};

const GameHowToPlayContext = React.createContext<GameHowToPlayContextType | undefined>(undefined);

export const GameHowToPlayProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<GameHowToPlayModalRef>(null);

    const showGameHowToPlay = useCallback((content: HowToPlayContent) => {
        modalRef.current?.show(content);
    }, []);

    return (
        <CustomBottomSheetModalProvider>
            <GameHowToPlayContext.Provider value={{ showGameHowToPlay }}>
                {children}
                <GameHowToPlayModal ref={modalRef} />
            </GameHowToPlayContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const useGameHowToPlay = () => {
    const context = useContext(GameHowToPlayContext);
    if (context === undefined) {
        throw new Error('useGameHowToPlay must be used within a GameHowToPlayProvider');
    }
    return context;
};
